import {AfterViewInit, Component, OnInit} from '@angular/core';
import {LOOKUP_ENUM} from 'app/dictionary/core/lookup.enum';
import {PageDetailsComponent} from '../../core/page-details.component';
import {Quote} from '../core/quote';
import {PageContext} from '../../core/page.context';
import {UserSettingsService} from '../../user/core/user-settings.service';
import {IMessagesResourceService, ResourcesService} from '../../core/resources/resources.service';
import {ActivatedRoute, Router} from '@angular/router';

const SYSTEM_MODULE = LOOKUP_ENUM.SYSTEM_MODULE;
const QUOTE_SERVICE_TYPE = LOOKUP_ENUM.QUOTING_SERVICE_TYPE;
const QUOTE_SERVICE_OFFER_METHOD = LOOKUP_ENUM.QUOTE_SERVICE_OFFER_METHOD;
const QUOTE_SERVICE_OFFER_STATUS = LOOKUP_ENUM.QUOTE_SERVICE_OFFER_STATUS;

@Component({
  selector: 'app-quote-details',
  templateUrl: './quote-details.component.html',
  styleUrls: ['./quote-details.component.css'],
  standalone: false
})
export class QuoteDetailsComponent extends PageDetailsComponent implements OnInit, AfterViewInit {
  private readonly MESSAGES_MODULE: string = 'quote';

  public readonly TAB_TYPES = {
    SUMMARY: 0,
    OVERVIEW: 1
  };

  public pageTitle = 'Quote Details';
  public selectedTabIndex = 0;

  public messages: IMessagesResourceService;
  public quote: Quote;

  constructor(
    private settingsService: UserSettingsService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(new PageContext({
      name: 'app.quoting.quoting-details',
      settings: settingsService
    }));

    this.messages = ResourcesService.messages(this.MESSAGES_MODULE);
  }

  back() {
    if (document.referrer.indexOf(window.location.host) >= 0 || document.referrer === '') {
      history.back();
    } else {
      this.router.navigate(['/quotes']);
    }
  }

  ngOnInit(): void {
    this.quote = this.route.data['quote'];
    this.pageTitle = this.quote.quote_id;
  }

  onTabSelectedIndexChange(index) {
    this.selectedTabIndex = index;
  }
}
